import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const ExpenseCategoryList = () => {
  const location = useLocation();
  const [categoryData, setCategoryData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await Http.get(`/accounts/expense-categories`);
      const resRole = await Http.get(`/staff-type-check`);
      setCategoryData(res.data);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);



  const cols = [
    { field: "name", header: "Category Name" },
    { field: "description", header: "Description" },
    { field: "created_by.name", header: "Created By" }
  ];

  const actionTemplate = (item) => {
    return (
      <td className="text-xs text-center">
        <Link
          to={{
            pathname: "/view-expense-category/" + item.id,
          }}
          className="btn btn-info btn-sm ms-1"
          title="View Category"
        >
          <i className="fa fa-list" aria-hidden="true"></i>
        </Link>
        {(role === "admin" || role === "supply_chain") && (
          <Link
            to={{
              pathname: "/edit-expense-category/" + item.id,
            }}
            className="btn btn-primary btn-sm ml-1"
            title="Edit"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </Link>
        )}
      </td>
    );
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Expense Categories</h5>
            <div className="am-right">
              {(role === "admin" || role === "supply_chain") && (
                <Link
                  to="/create-expense-category"
                  className="btn btn-primary"
                >
                  <i className="fa fa-plus"></i> Add New Expense Category
                </Link>
              )}
            </div>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={categoryData}
                isLoading={loading}
                actionTemplate={actionTemplate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseCategoryList;